import React from 'react';
import { CTABand } from '../../components/CTABand';
export function Page31FinalCTA() {
  return <CTABand headline="Ready to Start at Storm Taekwondo?" copy="Submit the form or call 517-220-0621. A Storm coach will help you pick the right starting class for your age and goals, and share current trial and enrollment options." data-id="element-2750" />;
}